import { Stack } from "@mui/material";
import type {
  FacilityTerminalDto,
  TerminalItemDto,
} from "Infrastructure/Api/Api";
import { FacilityTerminals } from "Components/Merchants/OrbitLOnboarding/FacilityTerminals";

type Props = {
  facilityTerminals: Array<FacilityTerminalDto>;
  onSwapClick: (terminal: TerminalItemDto) => void;
};

export const FacilityTerminalsList = ({
  facilityTerminals,
  onSwapClick,
}: Props) => (
  <Stack gap={2}>
    {facilityTerminals.map((facility, index) => (
      <FacilityTerminals
        key={facility.facilityName ?? facility.facilityAddress ?? index}
        facility={facility}
        onSwapClick={onSwapClick}
      />
    ))}
  </Stack>
);
